var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.486 2.63845C18.1256 1.85442 17.5474 1.18937 16.8194 0.72184C16.0915 0.254313 15.2443 0.00383892 14.3779 0C12.2247 0 10.7444 1.32985 9.49722 2.88072C8.32594 1.47105 6.62406 0 4.62271 0C3.75639 0.00358315 2.9092 0.253847 2.18124 0.72122C1.45328 1.18859 0.874978 1.85355 0.514663 2.63751C-0.567402 4.9043 0.0742435 7.7444 2.27492 10.4296C4.27597 12.7144 6.42389 14.8677 8.70514 16.8758L8.84087 17H10.1593L10.295 16.8758C12.5765 14.8678 14.7246 12.7145 16.7257 10.4296C18.9254 7.74487 19.5671 4.90524 18.486 2.63845Z",
    fill: "#175EDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart-filled.4abc0e341ffc2d22bb2e2963ef3dc7d7.svg";
export { ForwardRef as ReactComponent };